// English names for the languages offered by Google Website Translate,
// keyed by the codes used in its language select ("iw" is exposed as "he").
export const googleLanguageNames = {
  aa: "Afar",
  ab: "Abkhaz",
  ace: "Acehnese",
  ach: "Acholi",
  af: "Afrikaans",
  ak: "Twi (Akan)",
  alz: "Alur",
  am: "Amharic",
  ar: "Arabic",
  as: "Assamese",
  av: "Avar",
  awa: "Awadhi",
  ay: "Aymara",
  az: "Azerbaijani",
  ba: "Bashkir",
  bal: "Baluchi",
  ban: "Balinese",
  bbc: "Batak Toba",
  bci: "Baoulé",
  be: "Belarusian",
  bem: "Bemba",
  ber: "Tamazight (Tifinagh)",
  "ber-Latn": "Tamazight",
  bew: "Betawi",
  bg: "Bulgarian",
  bho: "Bhojpuri",
  bik: "Bikol",
  bm: "Bambara",
  "bm-Nkoo": "NKo",
  bn: "Bengali",
  bo: "Tibetan",
  br: "Breton",
  bs: "Bosnian",
  bts: "Batak Simalungun",
  btx: "Batak Karo",
  bua: "Buryat",
  ca: "Catalan",
  ce: "Chechen",
  ceb: "Cebuano",
  cgg: "Kiga",
  ch: "Chamorro",
  chk: "Chuukese",
  chm: "Meadow Mari",
  ckb: "Kurdish (Sorani)",
  cnh: "Hakha Chin",
  co: "Corsican",
  crh: "Crimean Tatar (Cyrillic)",
  "crh-Latn": "Crimean Tatar (Latin)",
  crs: "Seychellois Creole",
  cs: "Czech",
  cv: "Chuvash",
  cy: "Welsh",
  da: "Danish",
  de: "German",
  din: "Dinka",
  doi: "Dogri",
  dov: "Dombe",
  dv: "Dhivehi",
  dyu: "Dyula",
  dz: "Dzongkha",
  ee: "Ewe",
  el: "Greek",
  en: "English",
  eo: "Esperanto",
  es: "Spanish",
  et: "Estonian",
  eu: "Basque",
  fa: "Persian",
  "fa-AF": "Dari",
  ff: "Fulani",
  fi: "Finnish",
  fj: "Fijian",
  fo: "Faroese",
  fon: "Fon",
  fr: "French",
  "fr-CA": "French (Canada)",
  fur: "Friulian",
  fy: "Frisian",
  ga: "Irish",
  gaa: "Ga",
  gd: "Scots Gaelic",
  gl: "Galician",
  gn: "Guarani",
  gom: "Konkani",
  gu: "Gujarati",
  gv: "Manx",
  ha: "Hausa",
  haw: "Hawaiian",
  he: "Hebrew",
  hi: "Hindi",
  hil: "Hiligaynon",
  hmn: "Hmong",
  hr: "Croatian",
  hrx: "Hunsrik",
  ht: "Haitian Creole",
  hu: "Hungarian",
  hy: "Armenian",
  iba: "Iban",
  id: "Indonesian",
  ig: "Igbo",
  ilo: "Ilocano",
  is: "Icelandic",
  it: "Italian",
  iu: "Inuktut (Syllabics)",
  "iu-Latn": "Inuktut (Latin)",
  ja: "Japanese",
  jam: "Jamaican Patois",
  jw: "Javanese",
  ka: "Georgian",
  kac: "Jingpo",
  kek: "Q'eqchi'",
  kg: "Kikongo",
  kha: "Khasi",
  kk: "Kazakh",
  kl: "Kalaallisut",
  km: "Khmer",
  kn: "Kannada",
  ko: "Korean",
  kr: "Kanuri",
  kri: "Krio",
  ktu: "Kituba",
  ku: "Kurdish (Kurmanji)",
  kv: "Komi",
  ky: "Kyrgyz",
  la: "Latin",
  lb: "Luxembourgish",
  lg: "Luganda",
  li: "Limburgish",
  lij: "Ligurian",
  lmo: "Lombard",
  ln: "Lingala",
  lo: "Lao",
  lt: "Lithuanian",
  ltg: "Latgalian",
  lua: "Tshiluba",
  luo: "Luo",
  lus: "Mizo",
  lv: "Latvian",
  mad: "Madurese",
  mai: "Maithili",
  mak: "Makassar",
  mam: "Mam",
  mfe: "Mauritian Creole",
  mg: "Malagasy",
  mh: "Marshallese",
  mi: "Maori",
  min: "Minang",
  mk: "Macedonian",
  ml: "Malayalam",
  mn: "Mongolian",
  "mni-Mtei": "Meiteilon (Manipuri)",
  mr: "Marathi",
  ms: "Malay",
  "ms-Arab": "Malay (Jawi)",
  mt: "Maltese",
  mwr: "Marwadi",
  my: "Myanmar (Burmese)",
  ndc: "Ndau",
  "ndc-ZW": "Ndau",
  ne: "Nepali",
  new: "Nepalbhasa (Newari)",
  nhe: "Nahuatl (Eastern Huasteca)",
  nl: "Dutch",
  no: "Norwegian",
  nr: "Ndebele (South)",
  nso: "Sepedi",
  nus: "Nuer",
  ny: "Chichewa",
  oc: "Occitan",
  om: "Oromo",
  or: "Odia (Oriya)",
  os: "Ossetian",
  pa: "Punjabi (Gurmukhi)",
  "pa-Arab": "Punjabi (Shahmukhi)",
  pag: "Pangasinan",
  pam: "Pampanga",
  pap: "Papiamento",
  pl: "Polish",
  ps: "Pashto",
  pt: "Portuguese (Brazil)",
  "pt-PT": "Portuguese (Portugal)",
  qu: "Quechua",
  rn: "Rundi",
  ro: "Romanian",
  rom: "Romani",
  ru: "Russian",
  rw: "Kinyarwanda",
  sa: "Sanskrit",
  sah: "Yakut",
  sat: "Santali (Ol Chiki)",
  "sat-Latn": "Santali (Latin)",
  scn: "Sicilian",
  sd: "Sindhi",
  se: "Northern Sami",
  sg: "Sango",
  shn: "Shan",
  si: "Sinhala",
  sk: "Slovak",
  sl: "Slovenian",
  sm: "Samoan",
  sn: "Shona",
  so: "Somali",
  sq: "Albanian",
  sr: "Serbian",
  ss: "Swati",
  st: "Sesotho",
  su: "Sundanese",
  sus: "Susu",
  sv: "Swedish",
  sw: "Swahili",
  szl: "Silesian",
  ta: "Tamil",
  tcy: "Tulu",
  te: "Telugu",
  tet: "Tetum",
  tg: "Tajik",
  th: "Thai",
  ti: "Tigrinya",
  tiv: "Tiv",
  tk: "Turkmen",
  tl: "Filipino",
  tn: "Tswana",
  to: "Tongan",
  tpi: "Tok Pisin",
  tr: "Turkish",
  trp: "Kokborok",
  ts: "Tsonga",
  tt: "Tatar",
  tum: "Tumbuka",
  ty: "Tahitian",
  tyv: "Tuvan",
  udm: "Udmurt",
  ug: "Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vec: "Venetian",
  vi: "Vietnamese",
  war: "Waray",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  yua: "Yucatec Maya",
  yue: "Cantonese",
  zap: "Zapotec",
  "zh-CN": "Chinese (Simplified)",
  "zh-TW": "Chinese (Traditional)",
  zu: "Zulu",
};
